<div class="section-divider"></div>

<section class="hero">
  <div id="bwa-canvas"></div>

  <div class="container hero-grid">
    <div class="hero-text">
      <h1>A <span>NF</span><br>
        PERFORMANCE CLUB
      </h1>
      <p class="light">
        Mais do que uma academia, uma experiência de treino <br />
        criada para quem busca qualidade de vida através <br />
        das artes marciais.
      </p>
      <p>
        Localizada na Vila Olímpia, a NF une estrutura premium, <br />
        treinos dinâmicos e uma comunidade exclusiva para quem <br />
        busca evoluir com intensidade, levezae acompanhamento <br />
        próximo.
      </p>
      <div class="hero-actions">
        <app-btn i_type="primary-line" i_destiny="whatsapp" i_label="BTN.WHATSAPP"></app-btn>
        <app-btn i_type="second-line" i_destiny="register" i_label="BTN.REGISTER"></app-btn>
        
      </div>

      <!-- <span class="hero-hashtag"><b>#</b>everydayanewfight</span> -->
    </div>

    <div class="hero-visual">
      
    </div>
  </div>

</section>

<div class="section-divider"></div>

<section id="location" class="section" style="position: relative;">
  <!-- <img _ngcontent-ng-c230247093="" src="assets/mock/map.png" alt="" style="
    position: absolute;right: 3vw;top: 0;opacity: .18;width: auto;height: 100%;"> -->

  <div class="container">

    <h2 class="section-title">LOCALIZAÇÃO</h2>

    <ul class="info">
      <li>
        <h4>Vila Olímpia • São Paulo </h4>
        <div>
          <fa-icon [icon]="faMapMarkerAlt" />
          <p>
            Rua Casa do ator, 1110 <br/>
          </p>
        </div>
      </li>
      <li>
        <div class="actions">
          <app-btn i_type="primary-line mid" i_destiny="whatsapp" i_label="BTN.WHATSAPP"></app-btn>
          <app-btn i_type="second-line mid" i_destiny="maps" i_label="BTN.MAPS"></app-btn>
      </div>
      </li>
    </ul>

    <div class="map">
      <img src="assets/mock/map.png" alt="" />
    </div>

  </div>
</section>

<div class="section-divider"></div>

<section id="modalidades" class="section">
  <div class="container">

    <h2 class="section-title">MODALIDADES</h2>
    <br/>

    <ul>
        <li>
          <app-card i_card="studio" i_type="services" />
        </li>
        <li>
          <app-card i_card="outsourcing" i_type="services" />
        </li>
        <li>
          <app-card i_card="security" i_type="services" />
        </li>
    </ul>

  </div>
</section>

<div class="section-divider"></div>

<section id="treinos" class="section">
  <div class="container">

    <div class="left">
      <h2 class="section-title">TREINO</h2>

      <ul>
        <li>
          <h4>TREINOS DINÂMICOS E EFICIENTES</h4>
          <p>
            Métodos que entregam resultado real <br/>em menos tempo.
          </p>
        </li>
        <li>
          <h4>GRUPOS REDUZIDOS</h4>
          <p>
            Mais atenção, correção e evolução <br/>individual.
          </p>
        </li>
        <li>
          <h4>CONDICIONAMENTO COMPLETO</h4>
          <p>
            Força, resistência, mobilidade, agilidade <br/>e saúde.
          </p>
        </li>
        <li>
          <h4>CORPO, MENTE E ESTILO DE VIDA</h4>
          <p>
            Mais do que treinar, é sobre se tornar <br/>sua melhor versão.
          </p>
        </li>
      </ul>

    </div>

    <div class="right">
      <h2 class="section-title">NOSSO ESPAÇO</h2>

      <ul *ngIf="model_pics" style="padding-bottom: 30px;">
          <li *ngFor="let p of model_pics">
              <a *ngIf="p.name != 'init'"> 
                  <img src="{{ 'http://haylie.bosswebapps.net/gallery/' + p.name }}" width="98%" />
              </a>
              
          </li>
      </ul>

      <br/><br/>

      <app-btn i_type="more-line" i_destiny="arena" i_label="BTN.SEEMORE"></app-btn>
      
    </div>

  </div>
</section>

<div class="section-divider"></div>

<!--  -->
<section id="block3" class="section">
  <div class="container">

    <ul>
      <li>
        <h2 class="section-title">AGENDA</h2>

        <p></p>

        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>

        <app-btn i_type="primary-line" i_destiny="agenda" i_label="BTN.SEEAGENDAFULL"></app-btn>
      
      </li>
      <li>
        <h2 class="section-title">PACOTES</h2>

        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
          
        <app-btn i_type="primary-line" i_destiny="plans" i_label="BTN.SEEPACKAGESFULL"></app-btn>
      
      </li>
      <li>
        <h1>FAÇA PARTE  <br>
          <span>DA COMUNIDADE </span>
        </h1>
        <p>
          Treino forte, ambiente leve e uma <br/>
          comunidade que te impulsiona <br/>
          a ser a sua melhor versão.
        </p>
        <div class="hero-actions">
          <app-btn i_type="primary-line" i_destiny="whatsapp" i_label="BTN.WHATSAPP"></app-btn>
        
        </div>

      </li>
    </ul>

  </div>
</section>
<div class="section-divider"></div>